import { useCampaignCreateContext } from '@/pages/campaign/CreatePage/context';
import { CAMPAIGN_TABS } from '@/pages/campaign/CreatePage/types';
import { useAnalytics } from '@/services/analytics';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useCampaignAgent } from '../../hooks';
import { useRegisterExternalFields } from '../../hooks/useRegisterExternalFields';
import { Avatar } from './Avatar';
import { VideoPage } from './VideoPage';
import { VoiceScript } from './VoiceScript';

export const Content = observer(() => {
    const { currentTab } = useCampaignCreateContext();
    useRegisterExternalFields();
    const { isCreatingAgent } = useCampaignAgent();
    const mixpanel = useAnalytics();

    useEffect(() => {
        mixpanel?.track('campaigns-editor', { event: 'view', page: currentTab });
    }, [currentTab, mixpanel]);

    return (
        <>
            {currentTab === CAMPAIGN_TABS.AVATAR && <Avatar />}
            {currentTab === CAMPAIGN_TABS.VOICE_SCRIPT && <VoiceScript />}
            {currentTab === CAMPAIGN_TABS.VIDEO_PAGE && <VideoPage isCreatingAgent={isCreatingAgent} />}
        </>
    );
});
